<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<p class="sp"> </p>
<p class="ctfm"><span epub:type="pagebreak" id="pg_VII" title="VII"><span class="ePub-SC">CONTENTS</span></span></p>
<p class="tocfm"><a href="#/xhtml/illustration"><span class="ePub-I">List of Figures and Tables</span></a></p>
<p class="tocfm"><a href="#/xhtml/acronyms"><span class="ePub-I">Acronyms</span></a></p>
<p class="toc"><a href="#/xhtml/chapter1">1. The Benefits of Backlash: The Divergent Trajectories of LGBT-Rights Activism after Communism</a></p>
<p class="toc"><a href="#/xhtml/chapter2">2. EU Enlargement and LGBT Rights: “Returning to Europe” and Discovering a New World</a></p>
<p class="toc"><span href="#/xhtml/chapter3" title="Link target outside of Sample">3. How the Hard Right “Europeanized” Homosexuality: An Analysis of Party Rhetoric and Media Discourse</span></p>
<p class="toc"><span href="#/xhtml/chapter4" title="Link target outside of Sample">4. Activism before EU Leverage: Poland and the Czech Republic, 1980s–1997</span></p>
<p class="toc"><span href="#/xhtml/chapter5" title="Link target outside of Sample">5. Activism under EU Leverage: Poland and the Czech Republic, 1998–2004</span></p>
<p class="toc"><span href="#/xhtml/chapter6" title="Link target outside of Sample">6. Activism after EU Leverage: Poland and the Czech Republic, 2004–2012</span></p>
<p class="toc"><span href="#/xhtml/chapter7" title="Link target outside of Sample">7. Exploring Alternative Trajectories: Hungary, Slovakia, and Romania</span></p>
<p class="tocf"><span href="#/xhtml/conclusion" title="Link target outside of Sample">Conclusion: Leverage, Visibility, and Movement Success</span></p>
<p class="tocbmf"><span href="#/xhtml/acknowledgments" title="Link target outside of Sample"><span class="ePub-I">Acknowledgments</span></span></p>
<p class="tocbm"><span href="#/xhtml/appendix" title="Link target outside of Sample"><span class="ePub-I">Appendix</span></span></p>
<p class="tocbm"><span href="#/xhtml/notes" title="Link target outside of Sample"><span class="ePub-I">Notes</span></span></p>
<p class="tocbm"><span href="#/xhtml/bibliography" title="Link target outside of Sample"><span class="ePub-I">Bibliography</span></span></p>
<p class="tocbm"><span href="#/xhtml/index" title="Link target outside of Sample"><span class="ePub-I">Index</span></span></p>
<p class="tocbm"><span href="#/xhtml/abouttheauthor" title="Link target outside of Sample"><span class="ePub-I">About the Author</span></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?c576361c